<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            class="text-h5 font-weight-bold ml-3 page-header"
            >{{ $t("menu.agenda") }}</span
          >
        </template>
        <span v-html="$t('agenda.tipHAgenda')"></span>
      </v-tooltip>
      <v-btn icon x-small class="mx-2 mt-1" @click="openManual()">
        <v-icon class="pt-2" color="#404040">mdi-alert-circle-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="false">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            v-if="$security.checkUserAccess('CreateAgenda') && false"
            @click.stop="CreateAgenda()"
            color="primaryDark2"
          >
            <v-icon>mdi-plus</v-icon> {{ $t("agenda.btnCreateAgenda") }}
          </a-btn>
        </template>
        <span> {{ $t("agenda.tipCreateAgenda") }}</span>
      </v-tooltip>
      <v-tooltip bottom :disabled="!isMeetingCreated">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            :disabled="!isMeetingCreated"
            v-bind="attrs"
            v-on="on"
            @click.stop="createMeeting()"
            color="primaryDark2"
            class="ml-4"
          >
            <v-icon>mdi-plus</v-icon>{{ $t("CreateMeeting") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.tipCreateMeeting") }} </span>
      </v-tooltip>
    </template>

    <template v-slot:page-content>
      <v-row>
        <v-col cols="12" sm="12" md="12" v-if="Loaderloading">
          <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, article, list-item"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-two-line, list-item-two-line, article, list-item"
          ></v-skeleton-loader>
        </v-col>
        <agenda-meeting-view
          v-else
          ref="agendaMeetingView"
          :search="agendaViewSearchText"
        ></agenda-meeting-view>
        <message-sheet
          :showMessage="displayMessage"
          :message="message"
          :messageType="messageType"
          @close="displayMessage = false"
        >
        </message-sheet>
        <agenda-page
          :agendaObject="agendaFormData"
          v-if="dialogAgenda"
          v-model="dialogAgenda"
          @alert="onAlertMessage"
        ></agenda-page>
        <MeetingView
          v-if="dialogMeeting"
          v-model="dialogMeeting"
          :selectedMeeting="meetingObject"
        ></MeetingView>
      </v-row>
    </template>
  </page-container>
</template>

<script>
import AgendaMaster from "@/components/agenda/AgendaMaster.vue";
import CalendarView from "./calendar-view/CalendarView.vue";
import Loader from "@/components/Loader";
import { mapActions, mapGetters, mapState } from "vuex";
import SearchInput from "../SearchInput.vue";
import LandingView from "../LandingView.vue";
import AgendaViewGrid from "./AgendaViewGrid.vue";
import AgendaMeetingView from "./AgendaMeetingView.vue";
import MessageSheet from "../MessageSheet.vue";
import AToolbar from "../../wrapper-component/AToolbar.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import AgendaPage from "@/components/agenda/agendaPage.vue";
import MeetingView from "@/components/agenda/meeting.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import { getDateRange } from "../../utils/util";

export default {
  name: "AgendaSettings",
  mixins: [SignalRMixin],
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
      displayMessage: false,
      messageType: "",
      message: "",
      activeComponent: null,
      // selectedTab: 0,
      tab2: null,
      gridRefresh: false,
      Loaderloading: true,
      search: "",
      isCached: false,
      dialogMeeting: false,
      dialogAgenda: false,
      meetingFormData: null,
      agendaFormData: {
        id: "",
        agendaName: "",
        category: "",
        meetingType: "",
        priority: "",
        frequency: "",
        resolutionType: "",
        topics: [],
        tenantid: sessionStorage.getItem("tenantId"),
        memo: "",
      },
    };
  },
  components: {
    AgendaMaster,
    CalendarView,
    Loader,
    SearchInput,
    LandingView,
    AgendaViewGrid,
    AgendaMeetingView,
    MessageSheet,
    AToolbar,
    ABtn,
    AgendaPage,
    MeetingView,
  },
  computed: {
    ...mapState({
      meetingListData: (state) => state.meeting.meetingsList,
      meetingDetails: (state) => state.meeting.meetingDetails,
      activeAgendaUITab: (state) => state.agenda.activeAgendaUITab
    }),
    ...mapGetters({
      meetingTypes: "tenant/agendaMeetingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    agendaViewSearchText() {
      return this.search;
    },
    meetingObject() {
      return Object.assign({}, this.meetingFormData);
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    meetingTypesList() {
      return this.meetingTypes.filter((item) => {
        if (this.$security.checkMeetingTypeAccess(item.id, "CreateMeeting")) {
          return item;
        }
      });
    },
    isMeetingCreated() {
      return Boolean(this.meetingTypesList.length);
    },
  },
  async mounted() {
    try {
      this.Loaderloading = true;
      const target = "meeting_" + this.selectedTenant;
      const targetAgenda = "meeting_agenda_" + this.selectedTenant;
      await this.signalRInit(target);
      await this.signalRInit(targetAgenda);
      await this.getTenantConfigList();
      // const p1 = this.getMeetingListApi();
      const p1 = this.setDefaultFilterApi();
      const p2 = this.getAgendaListApi();
      await Promise.all([p1, p2]);
      this.Loaderloading = false;
      this.$root.$on("meetingAlert", (params) => {
        this.showMessageSheet(params);
      });
      this.$root.$on("loadMeetings", async () => {
        this.Loaderloading = true;
        await this.getMeetingListApi();
        this.Loaderloading = false;
      });
    } catch (error) {
      this.Loaderloading = false;
    }
  },
  beforeDestroy() {
    this.$root.$off("meetingAlert");
    this.$root.$off("loadMeetings");
  },
  methods: {
    ...mapActions({
      getAgendaListApi: "agenda/getAgendaList",
      getTenantConfigList: "tenant/getTenantConfigList",
      getMeetingListApi: "meeting/getMeetingList",
      getUserList: "admin/getUserList",
      setDefaultFilterApi: "meeting/setDefaultFilterType",
      getMeetingByAgendaId: "agenda/getMeetingByAgendaId",
    }),
    onAgendaTabChange,
    showMessageSheet,
    CreateAgenda,
    signalRInit,
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: "/usermanual",
        query: {
          content:
            this.$i18n.locale == "en"
              ? "Manual_E_Agenda.pdf"
              : "Manual_J_Agenda.pdf",
          id: this.$route.name,
        },
      });
      let popup;
      if (
        routeData &&
        (typeof this.manualWindow === "undefined" ||
          this.manualWindow.closed ||
          this.manualClick === 1)
      ) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      } else {
        this.manualWindow.focus();
      }
    },
    onAlertMessage: function (message, messageType) {
      this.showMessageSheet({ message: message, messageType: messageType });
    },
    createMeeting() {
      //this.editedItem = Object.assign({}, item);
      this.meetingFormData = this.resetMeetingObject();
      this.dialogMeeting = true;
      //this.$emit("onCreateMeeting", this.editedItem, true);
    },
    resetMeetingObject() {
      return {
        id: "",
        tenantid: this.selectedTenant,
        meetingName: "",
        meetingType: "",
        resolutionType: "",
        scheduletStartTimeInUTC: new Date().toISOString(),
        scheduledEndTimeInUTC: null,
        actualStartTimeInUTC: null,
        actualEndTimeInUTC: null,
        description: "",
        location: "",
        topics: [],
        documents: null,
        attendees: [],
        has_past_meetings: false,
        recurrenceData: {
          isMeetingRecurrence: false,
          recurrence_title: "",
          recurrenceStartDate: new Date().toISOString(),
          recurrenceEndDate: null,
          recurrencePattern: "month",
          repeatInterval: 1,
          selectedDays: [],
          recurrenceOnDay: {
            selectedValue: 0,
            day: new Date().getDate(),
            selectedWeekSlot: "first",
            selectedWeekDay: "sunday",
            selectedMonth: new Date().getMonth(),
          },
        },
      };
    },
  },
};

async function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    let dates = JSON.parse(localStorage.getItem(`currentAgendaUIYear#${sessionStorage.getItem("tenantId")}`));
    let date = new Date();
    let newDates = getDateRange(date);
    
    if(this.activeAgendaUITab === 0) {
      await this.getMeetingListApi();
    } else {
      const obj = {
        offset: 0,
        limit: 15,
        from_year: dates?.from_year || newDates.from_year,
        to_year: dates?.to_year || newDates.to_year
      };
      await this.getMeetingByAgendaId({obj, isLoadMore: false, initial: true});
      this.$refs?.agendaMeetingView?.scheduleData(this.$refs?.agendaMeetingView?.meetingsByAgenda, true);
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function showMessageSheet(params) {
  const { message, messageType } = { ...params };
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

async function onAgendaTabChange(value) {
  try {
    this.search = "";
    this.Loaderloading = true;
    await this.getAgendaListApi();
    await this.getMeetingListApi();
    this.Loaderloading = false;
  } catch (error) {
    this.Loaderloading = false;
  }
}
function CreateAgenda() {
  this.agendaFormData = {
    id: "",
    agendaName: "",
    category: "",
    meetingType: "",
    priority: "",
    frequency: "",
    resolutionType: "",
    topics: [],
    tenantid: this.selectedTenant,
    memo: "",
  };
  this.dialogAgenda = true;
}
</script>